import CountdownTag from "@/components/Countdown/CountdownTag.static";
import Accordion from "../components/Accordion/Accordion.static";
import AnchorNavigation from "../components/AnchorNavigation/AnchorNavigation.static";
import BlockAction from "../components/BlockAction/BlockAction.static";
import Carousel from "../components/Carousel/Carousel.static";
import CarouselHero from "../components/CarouselHero/CarouselHero.static";
import CarouselPromotions from "../components/CarouselPromotions/CarouselPromotions.static";
import Countdown from "../components/Countdown/Countdown.static";
import Dropdown from "../components/Dropdown/Dropdown.static";
import Expander from "../components/Expander/Expander.static";
import FeatureAccordion from "../components/FeatureAccordion/FeatureAccordion.static";
import Autocomplete from "../components/Forms/Autocomplete/Autocomplete.static";
import DatePicker from "../components/Forms/DatePicker/DatePicker.static";
import File from "../components/Forms/File/File.static";
import InputStepper from "../components/Forms/InputStepper/InputStepper.static";
import RangeSlider from "../components/Forms/RangeSlider/RangeSlider.static";
import Loader from "../components/Loader/Loader.static";
import Modal from "../components/Modal/Modal.static";
import Table from "../components/Table/Table.static";
import Tabs from "../components/Tabs/Tabs.static";
import Tooltip from "../components/Tooltip/Tooltip.static";
import { lowerCamelCase } from "../utils/helpers";

import moduleFactory, {
  destroyModulesWithin,
  initModulesWithin,
} from "./lib/moduleFactory";
import SameHeight from "./modules/SameHeight";
import Toggle from "./modules/Toggle";

export const moduleSelectorPairs = [
  {
    Module: Accordion,
    name: "Accordion",
    selector: "[data-accordion]",
  },
  {
    Module: AnchorNavigation,
    name: "AnchorNavigation",
    selector: "[data-anchor-navigation]",
  },
  {
    Module: Autocomplete,
    name: "Autocomplete",
    selector: "[data-autocomplete]",
  },
  {
    Module: DatePicker,
    name: "DatePicker",
    selector: "[data-datepicker]",
  },
  {
    Module: Dropdown,
    name: "Dropdown",
    selector: "[data-dropdown]",
  },
  {
    Module: Expander,
    name: "Expander",
    selector: "[data-expander]",
  },
  {
    Module: BlockAction,
    name: "BlockAction",
    selector: "[data-block-action]",
  },
  {
    Module: Carousel,
    name: "Carousel",
    selector: "[data-carousel]",
  },
  {
    Module: CarouselHero,
    name: "CarouselHero",
    selector: "[data-carousel-hero]",
  },
  {
    Module: CarouselPromotions,
    name: "CarouselPromotions",
    selector: "[data-carousel-promotions]",
  },
  {
    Module: Countdown,
    name: "Countdown",
    selector: "[data-countdown]",
  },
  {
    Module: CountdownTag,
    name: "CountdownTag",
    selector: "[data-countdown-tag]",
  },
  {
    Module: FeatureAccordion,
    name: "FeatureAccordion",
    selector: "[data-feature-accordion]",
  },
  {
    Module: File,
    name: "File",
    selector: "[data-file-input]",
  },
  {
    Module: Loader,
    name: "Loader",
    selector: "[data-loader]",
  },
  {
    Module: Modal,
    name: "Modal",
    selector: "[data-modal]",
  },
  {
    Module: SameHeight,
    name: "SameHeight",
    selector: "[data-same-height]",
  },
  {
    Module: RangeSlider,
    name: "RangeSlider",
    selector: "[data-rangeslider]",
  },
  {
    Module: InputStepper,
    name: "InputStepper",
    selector: "[data-inputstepper]",
  },
  {
    Module: Table,
    name: "Table",
    selector: "[data-table]",
  },
  {
    Module: Tabs,
    name: "Tabs",
    selector: "[data-tabs]",
  },
  {
    Module: Toggle,
    name: "Toggle",
    // selector: "[data-toggle], [aria-controls][aria-expanded]",
    selector: "[data-toggle]",
  },
  {
    Module: Tooltip,
    name: "Tooltip",
    selector: "[data-tooltip]",
  },
];

declare global {
  interface Window {
    ODS: {
      modules: Record<string, any>;
      instances: Record<string, any>;
      moduleSelectorPairs: Array<{
        name: string;
        Module: any;
        selector: string;
      }>;
      initModulesWithin: (container: any) => {};
      destroyModulesWithin: (
        container: any,
        removeOrphanedNodes?: boolean | undefined,
      ) => {};
    };
  }
}

window.ODS = window.ODS || {
  modules: {},
  instances: {},
  moduleSelectorPairs: {},
};
window.ODS.initModulesWithin = initModulesWithin;
window.ODS.destroyModulesWithin = destroyModulesWithin;
window.ODS.moduleSelectorPairs = moduleSelectorPairs;

window.addEventListener("DOMContentLoaded", () => {
  moduleSelectorPairs.forEach((module) => {
    window.ODS.modules[module.name] = module.Module;
    window.ODS.instances[lowerCamelCase(module.name)] = moduleFactory(
      module.Module,
      module.selector,
    );
  });

  window.dispatchEvent(new Event("ODSLoaded"));
});
